import { useMemo } from 'react';
import Config from 'config';

export const useConfig = () => {
  return useMemo(Config.get, []);
};
